/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Action_Reset_CredentialsInputs */



/**
* | output |
* | --- |
* | "Reset Credentials" |
*
* @param {Members_Action_Reset_CredentialsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_action_reset_credentials = /** @type {((inputs?: Members_Action_Reset_CredentialsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Action_Reset_CredentialsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldedaten zurücksetzen")
	return /** @type {LocalizedString} */ ("Reset Credentials")
});